import { render, staticRenderFns } from "./netPage.vue?vue&type=template&id=486837c6&scoped=true"
import script from "./netPage.vue?vue&type=script&lang=js"
export * from "./netPage.vue?vue&type=script&lang=js"
import style0 from "./netPage.vue?vue&type=style&index=0&id=486837c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486837c6",
  null
  
)

export default component.exports